import type { ReactiveController, ReactiveControllerHost } from 'lit'
import type { InputMixinInterface } from '../mixins/InputMixin.js'

interface FormDataOptions {
  value: () => string | undefined
}

export class FormDataController implements ReactiveController {
  private _form: HTMLFormElement | null = null

  constructor(
    private host: ReactiveControllerHost & InputMixinInterface,
    private options: FormDataOptions,
  ) {
    host.addController(this)
  }

  hostConnected() {
    this.listen(this.host.form)
  }

  hostUpdated() {
    this.listen(this.host.form)
  }

  hostDisconnected() {
    this.cleanup()
  }

  private listen(form: HTMLFormElement | null) {
    if (this._form !== form) {
      this.cleanup()
      this._form = form
      this._form?.addEventListener('formdata', this.handleFormData)
    }
  }

  private cleanup() {
    this._form?.removeEventListener('formdata', this.handleFormData)
    this._form = null
  }

  private handleFormData = (e: FormDataEvent) => {
    const { disabled, name } = this.host

    if (disabled) {
      return
    }
    if (!name) {
      return
    }

    const value = this.options.value()
    if (value != null) {
      e.formData.append(name, value)
    }
  }
}
